<template>
    <div class="container">
        <h1 style="text-align: center" class="mt-5">Reset password</h1>
        <div class="row justify-content-center my-4">
            <el-alert type="primary" title="Instructions" show-icon :closable="false">
                <p>In order to reset your password, please enter the email address of the {{ $appName }} account. Once your request is received, {{ $appName }} will send an email with further instructions at the address you specified.</p>
                <p v-if="userinfo?.email">Since you are already logged in, we have pre-filled the form using your account's information. If you wish to request a password reset for a different account, please enter that account's email address. Please note you will be logged out if you reset the password for the account you are logged in with.</p>
            </el-alert>
        </div>
        <div class="row justify-content-center">
            <el-form :model="formData" :rules="formRules" validate-on-rule-change label-position="top" ref="form" size="large" style="max-width: 400px">
                <el-form-item label="Email adress" prop="email">
                    <el-input v-model="formData.email" />
                </el-form-item>
                <el-form-item>
                    <el-button icon="Unlock" type="primary" @click="resetPassword">Reset password</el-button>
                </el-form-item>
            </el-form>
      </div>
    </div>
</template>

<script>
import api from '@/lib/api'
import {mapGetters, mapActions} from 'vuex'
import {ElMessageBox} from 'element-plus'

export default {
    name: 'ResetPassword',
    data: () => ({
        formData: {
            email: undefined   
        },
        formRules: {
            email: { type: 'email', required: true, message: "Please enter a valid email address." }
        }
    }),
    computed: {
        ...mapGetters('auth', ['userinfo', 'isLoggedIn'])
    },
    methods: {
        ...mapActions('auth', ['logout']),
        
        async resetPassword () {
            try {
                await this.$refs.form.validate()
            } catch {
                return
            }

            
            api.auth.resetPassword (this.formData.email)
            .then(() => {
                ElMessageBox.alert(
                    `Your request to reset the password was received by ${this.$appName}. If this is a valid ${this.$appName} user email you will receive an email with further instructions.`,
                    'Password reset request',
                    { type: 'success', confirmButtonText: 'Go to login' }
                )
                .then (() => {
                    if (!this.isLoggedIn || this.userinfo?.email === this.formData.email) {
                        this.logout().then (() => {this.$router.push({name: 'LoginPage'})})
                    }                    
                })
                .catch (() => {})
            })
            .catch (error => {
                const err = error?.response?.data?.message || error.message

                ElMessageBox.alert(`Error resetting password: ${err}`, 'Error', {type: 'error'})
                .catch (() => {})
            })
        }
    },
    mounted () {
        this.formData.email = this.userinfo?.email
    }
}
</script>